export type Review = {
    author_name: string
    author_url: string
    language?: string
    original_language?: string
    profile_photo_url: string
    rating: number
    relative_time_description: string
    text: string
    time: number
    translated: boolean
}

export const cachedReviews: Review[] = [
    {
        author_name: 'Ivana Flek',
        author_url: 'https://www.google.com/maps/contrib/113033048043999576129/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUP8bDnEfz5E1z7yL00zspFcIAIPY99iCXyCZLDICvY7zfSJo3E=s128-c0x00000000-cc-rp-mo-ba3',
        rating: 5,
        relative_time_description: 'v zadnjem tednu',
        text: 'Zelo prijetna izkusnja prvega obiska nasega malcka,priznam da sem bila v strahu kako se bo obnesal, a bo sploh odprl usta, in po tako prijetnem sprejemu moj Leon sploh ni hotel pejt domov. Zelo strokovno, hkrati pa zelo prijetna in topla obravnava. Vredna vsakega centa.\nPriporočam vsem mamicam katere se ne znajo kam peljat otroka na prvi pregled zobkov.\n\nVse pohvale Urška in Katja! ❤️',
        time: 1718302578,
        translated: false,
    },
    {
        author_name: 'Teja Kozan',
        author_url: 'https://www.google.com/maps/contrib/112726614307754444208/reviews',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocKJ57n5ExakqyZBK-3P9B4q3Qlxk8Ps_VPOgeu2nrCw-EQ_nA=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'v zadnjem tednu',
        text: '',
        time: 1718085259,
        translated: false,
    },
    {
        author_name: 'Zoran Farkaš',
        author_url: 'https://www.google.com/maps/contrib/107138270982334977828/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjU12541y7pAte0rEz4sc6v5c_6qRBuYdi_RHEou2qqfJERwWDOK=s128-c0x00000000-cc-rp-mo-ba4',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'Najboljša , najprijaznejša , sočutna zobozdravnica v Beli krajini.... 🥰\nSpuli zob brez ,da bi sploh kaj čutil 😁',
        time: 1698011906,
        translated: false,
    },
    {
        author_name: 'Katja Bahor',
        author_url: 'https://www.google.com/maps/contrib/110261297256656113381/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjVjGb1HEzf98qoR42yuwNhTNczVQUJ5ZnuHkmC2ICq5vPosgY5a=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'Prijazna, strokovna in komunikativna zobozdravnica, ki resnično dela z občutkom. Ponuja širok nabor zobozdravstvenih storitev, zaradi katerih se ni več potrebno odpeljati v Ljubljano. Prijeten in sproščujoč ambient. Zagotovo se še vrnem 😀.',
        time: 1696593279,
        translated: false,
    },
    {
        author_name: 'Zoran Farkaš',
        author_url: 'https://www.google.com/maps/contrib/107138270982334977828/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjU12541y7pAte0rEz4sc6v5c_6qRBuYdi_RHEou2qqfJERwWDOK=s128-c0x00000000-cc-rp-mo-ba4',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'Najboljša , najprijaznejša , sočutna zobozdravnica v Beli krajini.... 🥰\nSpuli zob brez ,da bi sploh kaj čutil 😁',
        time: 1698011906,
        translated: false,
    },
    {
        author_name: 'Boštjan Dolenc',
        author_url: 'https://www.google.com/maps/contrib/108481296949765928669/reviews',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUlvJ0QMNO_hbzjndzB3n-lxGcmWBOinh93E67jmbA7jYvwUH8=s128-c0x00000000-cc-rp-mo-ba5',
        rating: 5,
        relative_time_description: 'pred 9 meseci',
        language: 'sl',
        original_language: 'sl',
        text: '',
        time: 1691417061,
        translated: false,
    },
    {
        author_name: 'Nina Kapušin',
        author_url: 'https://www.google.com/maps/contrib/112671935274444397803/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjWdHYySFrcSn-gHDsdyNgtf6nYhEUXryAsN6A_eIjsgMeYHrcs=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 11 meseci',
        text: 'Otroku je razložen res vsak postopek in pripomocek, ki se bo približal njegovim zobkom. Otrok je pohvaljen in na koncu nagrajen, ter ponosen, kar se mi zdi zelo pomembno za nadaljne obiske.',
        time: 1686601117,
        translated: false,
    },
    {
        author_name: 'Mira',
        author_url: 'https://www.google.com/maps/contrib/102119478795611219679/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocJp6prSqWsYXCKsqQCG3hxBLAZjznDinCqj1PiX-XZ3wj7kyg=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred enim letom',
        text: 'Sproščujoč ambient, srčna, prijetna in strokovna zobozdravnica. Res si vzame čas in se posveti pacientu.\nNam je izkušnjo obiska zobozdravnika spremenila za 100%.',
        time: 1684509370,
        translated: false,
    },
    {
        author_name: 'Lidija Pezdirc',
        author_url: 'https://www.google.com/maps/contrib/107528924097610364108/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocJHa4cumm6I7T3ClZ4C4zIsVtICb7-U2e6DUmERfQlJfTDfbw=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred enim letom',
        text: 'Zelo prijazna in strokovno podkovana zobozdravnica, ki dela zelo nežno in ve kaj pomeni strah pri zobozdravniku. Zelo lep in sproščujoč ambient. Bili smo zelo zadovoljni.',
        time: 1684990760,
        translated: false,
    },
    {
        author_name: 'Katarina Vraničar',
        author_url: 'https://www.google.com/maps/contrib/104033738189140259737/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUXR0_fD5lPouqdkz1TLRMGphNIaBkTrPemjoXx_hw0Yhu5p8g=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred enim letom',
        text: 'Zares prijazen in profesionalen pristop, zobozdravnica dela nežno, predvsem mi je bilo všeč tudi svetovanje, kako ohraniti oz. izboljšati ustno higieno.',
        time: 1684741352,
        translated: false,
    },
    {
        author_name: 'Nika Banovec',
        author_url: 'https://www.google.com/maps/contrib/104124760239200489103/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLImZvOQhf2ORWaU2stlsQdqjInsJ_9WpRWiK_ArwOVpx0yYg=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'Odlična izkušnja, zelo pohvalno. Zobozdravnica ima res čut za otroka. Vredno vsakega centa 🙂',
        time: 1697480601,
        translated: false,
    },
    {
        author_name: 'Tanja Matkovič',
        author_url:
            'https://www.google.com/maps/contrib/110110164950738007011?hl=en-US&ved=1t:31294&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUjSWabtOfv1kQ0apT1Au-t31Lo69uraKTWOQ1UTfLaq7BJRu_t=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: 'Zelo prijazno osebje, sočutno. Prav za take ki se “bojijo” zobozdravnika. Zelo prijeten ambient.',
        time: 1685631345,
        translated: false,
    },
    {
        author_name: 'Karmen Križan',
        author_url:
            'https://www.google.com/maps/contrib/102834410123142713172?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLvXQB8qVhZVSv4wDlP0inQiUt8E-iVUn5nLwVn3Q6zNcQmyQ=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: 'Sočutno zobozdravstvo je prava izbira za velike in male.Hčerka je z veseljem po prvem obisku rekla, da komaj čaka naslednji obisk ker je zobozdravnica Urška super.Hvala, ker delate s srcem!',
        time: 1694363424,
        translated: false,
    },
    {
        author_name: 'Petra Žlogar Raztresen',
        author_url:
            'https://www.google.com/maps/contrib/103202169970283790039?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjX02YqcdYydqHVOi_Hc_TE4JfcLbFg0N7cXe1aghaMksz-KxJeH=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: 'Kot pove že ime; res sočutno zobozdravstvo! Bili smo zelo zadovoljni z obravnavo.',
        time: 1692721824,
        translated: false,
    },
    {
        author_name: 'Nina Koren',
        author_url:
            'https://www.google.com/maps/contrib/116194450023092046432?hl=en-US&ved=1t:31294&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUAgGVzVoqmzcd8kozSw4PSGODCdFx0bFrRKkdHTEhxlVUE5bwb=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: 'Zelo prijetna izkusnja prvega obiska nasega malcka, strokovno, hkrati pa zelo prijetna in topla obravnava. Priporocam',
        time: 1691857824,
        translated: false,
    },
    {
        author_name: 'helena lesica',
        author_url:
            'https://www.google.com/maps/contrib/105764737779095953804?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjU1o4_GSpQp3tIoroiuQCPRI6pClClnCRu2VZqz1Xn9P_GojlTp=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: '',
        time: 1689784224,
        translated: false,
    },
    {
        author_name: 'Dajana Car',
        author_url:
            'https://www.google.com/maps/contrib/102891702876198975200?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocKkBrivnUhJTjzrJJTB645xBfZSL45dKB_baKLROnlmiPyReQ=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: '',
        time: 1689438624,
        translated: false,
    },
    {
        author_name: 'Maja Štubljar Fendre',
        author_url: '',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLrwYTtHVNyQ28BUblNmS0w0U7N25KcQOkIPpdMnDrBcvTQ9A=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 8 meseci',
        text: '',
        time: 1726963200,
        translated: false,
    },
    {
        author_name: 'Aleksander Zbogar',
        author_url: '',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjWCpY8Ex6_RB_w6eS827KWMwf9DRsWKT4HxRnPljwdLpjd4jqmE=s64-c-rp-mo-ba2-br100',
        rating: 5,
        relative_time_description: 'pred 8 meseci',
        text: 'Zelo odzivni in prijazni, tudi do termina sem prišel hitro.',
        time: 1724284800,
        translated: false,
    },
    {
        author_name: 'Tanja Derzanic',
        author_url: 'https://www.google.com/maps/contrib/104914988084508857700/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjXvPxIlRjZCmWsS0hfTNdsrJ6uqNmcB902rQx0mjM5x0wM207zu=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'v zadnjem tednu',
        text: 'Urška in Katja sta najbolj sočutne zobozdravstvene delavke s katerimi sem se kadarkoli srečala, a veliko posegov v zobeh sem že imela pri različnih zobozdravnikih. V nobeni ambulanti nisem imela še pristopa in načina kot pri njiju, kar mi je zelo pomembno, ker imam velik strah in veliko problemov od rane mladosti. Najbrž je tudi strah se ukoreninil od prejšnjih izkušenj, ko so me med posegi kr "špotali" in masakrirali. Urška in Katja sta lahko primer lokalnim zobozdravnikom, s svojo predanostjo, pristopom, sočutjem, znanjem in opremo. Tudi otrok je njen pacient in vedno veselo gre na pregled, ker pravi "Urška je zakon"!. Bravo punce, samo tako naprej. Se vidmo kmalu :)',
        time: 1747842935,
        translated: false,
    },
    {
        author_name: 'Rok Narobe',
        author_url: 'https://www.google.com/maps/contrib/110959652861350961764/reviews',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocKgTQlDUWruoNXAOvxbDiXgAOoaNn0PyLvQJtLdhTRPuldDqg=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 3 meseci',
        text: '',
        time: 1738304106,
        translated: false,
    },
    {
        author_name: 'Katja Mercina',
        author_url: 'https://www.google.com/maps/contrib/103519512429682180252/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjX9x5HbMdugRRSbV7NPXRriedy49WHR4ORMrPy2jEUD61tW0TLP=s128-c0x00000000-cc-rp-mo-ba2',
        rating: 5,
        relative_time_description: 'pred 4 meseci',
        text: 'Najboljša zobozdravnica za otroke, sploh če so malo plašni. Navdušena, 100x hvala za tvoj pristop ',
        time: 1736148925,
        translated: false,
    },
    {
        author_name: 'jasmina lesjak',
        author_url: 'https://www.google.com/maps/contrib/105344660123268688310/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLkrUf3hphV_tHhaFy6HtgcQv5Ggv2tuDUQ3T7GbmH0nZIRHkY=s128-c0x00000000-cc-rp-mo-ba3',
        rating: 5,
        relative_time_description: 'pred 5 meseci',
        text: 'Zobozdravnica nežna, z občutkom, strokovna, natancna. Asistentka pa izredno prijazna, nasa malcica je bila navdusena! Smo bili zelo zadovoljni, se bomo z veseljem vrnili. Prijetna izkusnja, priporocam! ☺️',
        time: 1734087045,
        translated: false,
    },
    {
        author_name: 'Boris K.',
        author_url: 'https://www.google.com/maps/contrib/113886937631847299461/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUmiGlYzHAPRHSmtTKNQ6Pz_Fz1esgIC0gxXfUVBAR6HjT86HNj=s128-c0x00000000-cc-rp-mo-ba3',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'Zelo sem zadovoljen in vesel, da sem poiskal pomoč in se odločil za to zobno ordinacijo, saj mi je z njihovo pomočjo v pol leta uspelo urediti prej razmaknjene in manjkajoče zobe v popoln nasmeh.\nRezultat je 100%!\nNaj vam priložena fotka pove vse.\n\nSočutno ni samo ime ordinacije, to je res njihov moto in način dela.\nOrdinacijo priporočam vsakomur, v čakalnici sem se nekajkrat pogovarjal z mamicami, ki so tja pripeljale svoje otročke, in vse so bile navdušene nad pristopom zobozdravnice, dr. Urške Šavli.\n\nDa ne bi mislili, da sem v ordinaciji čakal, da pridem na vrsto: nikakor ne, termini za obisk so lepo razporejeni, moja srečanja in pogovori z mladimi pacienti in njihovimi mamicami so se zgodila, kadar sem v ordinacijo na poseg pripeljal mojo ženo, ki je tudi zelo zadovoljna s procesom uravnavanja zob z uporabo Invisiline protetike.',
        time: 1728893728,
        translated: false,
    },
]
